import React, { useState, useEffect, useCallback } from 'react';
import styles from './AddressInput.module.scss'; // Make sure to update this import based on your file structure
import { AddressParts } from '../../Pages/Home/HomePageTypes';

interface Props {
  onUpdate: (address: AddressParts) => void;
}

function AddressInput({ onUpdate }: Props): JSX.Element {
  const [fullAddress, setFullAddress] = useState<string>('');
  const [expandedAddress, setExpandedAddress] = useState<AddressParts | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFullAddress, setShowFullAddress] = useState<boolean>(true); // Add this line


  useEffect(() => {
    if (isLoading) {
      fetchExpandedAddress();
    }
  }, [isLoading]);

  const fetchExpandedAddress = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await fetch(`http://localhost:3400/expand-address?address=${encodeURIComponent(fullAddress)}`);
      const data = await response.json();
      setExpandedAddress(data);
      onUpdate(data);
    } catch (error) {
      console.error('Error fetching expanded address:', error);
    } finally {
      setIsLoading(false);
      setShowFullAddress(false); // Hide the full address field after fetching
    }
  };

  const handleInputChange = useCallback((field, value) => {
    if (expandedAddress) {
      const updatedAddress = { ...expandedAddress, [field]: value };
      setExpandedAddress(updatedAddress);
      onUpdate(updatedAddress);
    }
  }, [expandedAddress, onUpdate]);


  const inputFields: { label: string, field: keyof AddressParts }[] = [
    { label: 'Street Name', field: 'street_name' },
    { label: 'Street Number', field: 'street_number' },
    { label: 'City', field: 'city' },
    { label: 'State', field: 'state' },
    { label: 'Country', field: 'country' },
    { label: 'Postal Code', field: 'postal_code' },
  ];

  return (
    <div>
      {showFullAddress && (
        <input
          type="text"
          placeholder="Enter full address"
          value={fullAddress}
          onChange={(e) => setFullAddress(e.target.value)}
          onBlur={() => setIsLoading(true)}
        />
      )}

      {isLoading ? (
        <p>Loading...</p>
      ) : expandedAddress ? (
        <div className={styles.allAddrContainer}> {/* Added parent container */}
          <div className="allAddr"> {/* This div holds the content */}
            {inputFields.map(({ label, field }) => (
              <div className={styles.addressContainer} key={field}>
                <label>{label}</label>
                <input
                  type="text"
                  value={expandedAddress[field]}
                  placeholder={label}
                  onChange={(e) => handleInputChange(field, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}


export default AddressInput;
